/**
 * @generated SignedSource<<129e556b6f0aca170e46c9570ef86254>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RankingUserOrderBy = "TOTAL_POINTS" | "TOTAL_POINTS_CURRENT_MONTH" | "TOTAL_POINTS_LAST_3_MONTHS" | "TOTAL_POINTS_LAST_MONTH" | "%future added value";
export type sidebarPreviewLeaderboardQuery$variables = {
  id: string;
  orderBy?: RankingUserOrderBy | null | undefined;
};
export type sidebarPreviewLeaderboardQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"sidebarPreviewLeaderboard">;
  } | null | undefined;
};
export type sidebarPreviewLeaderboardQuery = {
  response: sidebarPreviewLeaderboardQuery$data;
  variables: sidebarPreviewLeaderboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sidebarPreviewLeaderboardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v3/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "sidebarPreviewLeaderboard"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "sidebarPreviewLeaderboardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClubRanking",
                "kind": "LinkedField",
                "name": "ranking",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 5
                      },
                      {
                        "kind": "Literal",
                        "name": "order",
                        "value": "DESC"
                      },
                      (v3/*: any*/)
                    ],
                    "concreteType": "RankingUserConnection",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RankingUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RankingUser",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ImageFile",
                                    "kind": "LinkedField",
                                    "name": "photo",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "signedUrl",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "username",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "avatarFallback",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalPoints",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalPointsCurrentMonth",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalPointsLast3Months",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalPointsLastMonth",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Club",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "638a572c3149cb7b7b1ee643fc9d3ffd",
    "id": null,
    "metadata": {},
    "name": "sidebarPreviewLeaderboardQuery",
    "operationKind": "query",
    "text": "query sidebarPreviewLeaderboardQuery(\n  $orderBy: RankingUserOrderBy\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...sidebarPreviewLeaderboard_7FfCv\n    id\n  }\n}\n\nfragment sidebarPreviewLeaderboard_7FfCv on Club {\n  ranking {\n    users(first: 5, orderBy: $orderBy, order: DESC) {\n      edges {\n        node {\n          user {\n            displayName\n            photo {\n              signedUrl\n              id\n            }\n            username\n            avatarFallback\n            id\n          }\n          totalPoints\n          totalPointsCurrentMonth\n          totalPointsLast3Months\n          totalPointsLastMonth\n        }\n        cursor\n      }\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "f0b4c9ecb6a9adb62f8a3d12f35e6abc";

export default node;
